export const legalModalMarkup = String.raw`
<div class="modal-overlay legal-reader-overlay" id="legalDocumentModal" hidden>
  <div class="modal legal-reader" role="dialog" aria-modal="true" aria-labelledby="legalDocumentTitle">
    <header class="legal-reader-header">
      <h2 id="legalDocumentTitle">Legal document</h2>
      <div class="legal-reader-actions">
        <button type="button" class="modal-close legal-reader-close" data-proto-click="closeLegalDocument()" aria-label="Close legal document">
          <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>
        </button>
      </div>
    </header>
    <article class="legal-reader-content" id="legalDocumentContent" tabindex="0">
      <div class="legal-reader-loading">Preparing the document…</div>
    </article>
    <footer class="legal-reader-footer">
      <span>Questions about this document? <a id="legalDocumentContact" href="mailto:support@deepmox.com">support@deepmox.com</a></span>
    </footer>
  </div>
</div>`;
